export default "__VITE_ASSET__DlYjt3V9__"